BoardInvitation = require 'models/board-invitation'
InvitationList = require 'models/collections/invitation-list'

module.exports = class BoardInvitationList extends InvitationList
  model: BoardInvitation



// WEBPACK FOOTER //
// ./app/scripts/models/collections/board-invitation-list.coffee